module.exports = __webpack_public_path__ + "4fe31145957b22da7025ebb4305737bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/cover/cover.jpg
// module id = 263
// module chunks = 1